import type { TFunction } from 'i18next';
import type { RowAction } from 'design-system-web';

import {
  CoverageHoursTableRow,
  isCoverageHoursRouting,
} from './coverageHoursTableRows';
import { CoverageHoursRouting } from './useCoverageHours';

// A shift row is a sub-row of its routing; the routing owns the actions, so hiding both on a
// child leaves it with no menu at all rather than a menu that does nothing.
const isShiftBlockRow = (row: CoverageHoursTableRow) =>
  !isCoverageHoursRouting(row);

type CoverageHoursRowHandlers = {
  onEdit: (routing: CoverageHoursRouting) => void;
  // A pair load walks the windows a page at a time, so Edit has nothing to show
  // for a moment; disabling it stops a second click starting a competing walk.
  isEditDisabled: boolean;
  onDelete: (routing: CoverageHoursRouting) => void;
  isDeleteDisabled: boolean;
};

export function buildCoverageHoursRowActions(
  t: TFunction,
  {
    onEdit,
    isEditDisabled,
    onDelete,
    isDeleteDisabled,
  }: CoverageHoursRowHandlers
): RowAction<CoverageHoursTableRow>[] {
  return [
    {
      label: t('web.admin.serviceRequest.settings.coverageHours.actions.edit'),
      onClick: row => {
        if (isCoverageHoursRouting(row)) {
          onEdit(row);
        }
      },
      isHidden: isShiftBlockRow,
      isDisabled: isEditDisabled,
      testId: 'coverageHoursRowActionEdit',
    },
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.actions.delete'
      ),
      onClick: row => {
        if (isCoverageHoursRouting(row)) {
          onDelete(row);
        }
      },
      isHidden: isShiftBlockRow,
      isDisabled: isDeleteDisabled,
      testId: 'coverageHoursRowActionDelete',
    },
  ];
}
